import React, { useRef, useState, useEffect, useLayoutEffect } from 'react';
import AWS from 'aws-sdk';

import uuidv4 from '~/utils/uuid';
import isMobile from '~/utils/is-mobile';
import empty2null from '~/utils/empty2null';
import apiCall, { LIVE_URL, TEST_URL } from '~/utils/apiCall';

import BG from '~/components/background';

import form_top from '../images/form_top.png';
import submit_btn from '../images/submit_btn.png';
import close from '~/components/svg-icon/images/ic-24-close-gray-900.svg';

import {
  FormBody,
  FormWrap,
  Label, Input,
  RadioWrap, RadioLabel, Radio,
  IntroduceTitle,
  Textarea,
  UploadBtn,
  UploadFile,
  UploadText,
  TermsWrap,
  Checkbox,
  QuestionText,
  Overlay,
} from '../styled';

const S3_BUCKET = process.env.GATSBY_BUCKET;
const REGION = process.env.GATSBY_REGION;

AWS.config.update({
  accessKeyId: process.env.GATSBY_ACCESS_KEY_ID,
  secretAccessKey: process.env.GATSBY_SECRET_ACCESS_KEY,
});

const MAX_SIZE = 300 * 1024 * 1024;

const INIT = {
  name: '',
  phone: '',
  gender: '',
  email: '',
  collegeStatus: '',
  college: '',
  region: '',
  livingAloneExperience: '',
  livingAlonePeriod: '',
  instagramAccount: '',
  naverBlogAccount: '',
  introduce: '',
  role: '',
  description: '',
  portfolioUrl: '',
};

function Arrow({ fn }) {
  return (
    <svg width="40" height="40" viewBox="0 0 40 40" onClick={fn}>
      <g fill="none" fillRule="evenodd">
        <g>
          <g>
            <g>
              <path fill="#326CF9" d="M0 0H40V40H0z" transform="translate(-391.000000, -2172.000000) translate(0.000000, 2172.000000) translate(391.000000, 0.000000)"/>
              <path stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="4" d="M27 9L27 23 13 23" transform="translate(-391.000000, -2172.000000) translate(0.000000, 2172.000000) translate(391.000000, 0.000000) translate(20.000000, 16.000000) rotate(-315.000000) translate(-20.000000, -16.000000)"/>
          </g>
          </g>
        </g>
      </g>
  </svg>
  );
}

function TextareaComponent({ name, value, placeholder, changeState }) {
  const [isFocus, setFocus] = useState(false);

  return (
    <Textarea isFocus={isFocus}>
      <textarea name={name} value={value} placeholder={placeholder} onChange={changeState} onFocus={() => setFocus(true)} onBlur={() => setFocus(false)} />
      <div>{value.length} / 800</div>
    </Textarea>
  );
}

function SupportersForm() {
  const myBucket = new AWS.S3({
    params: { Bucket: S3_BUCKET },
    region: REGION,
  });

  const _file = useRef(null);

  const [isSending, setSending] = useState(false);
  const [agree, setAgree] = useState(false);
  const [open, setOpen] = useState(false);
  const [progress , setProgress] = useState(0);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [ids, setIds] = useState([]);
  const [state, setState] = useState(INIT);

  const isM = isMobile.any();

  useEffect(() => {
    if (isSending) document.body.style.overflow = 'hidden';
    else document.body.style.overflow = '';
  }, [isSending]);

  useLayoutEffect(() => {
    if (isM) {
      alert('본 이벤트는 웹환경에서만 가능합니다.');
      window.location.replace('/2022/05/supporters/');
    } 
  }, []);

  function clickOpenTerms(e) {
    e.preventDefault();
    setOpen(prev => !prev);
  }

  const clickSelectFile = e => {
    // 추가되는 파일 리스트 (원본)
    const files = e.currentTarget.files;
    // 용량, 확장자 필터된 파일 리스트
    const filterFiles = [...files].filter(file => {
      const extension = file.name.split(".").pop().toUpperCase();
      return file.size < MAX_SIZE && ['MP4', 'PDF'].includes(extension);
    });
    // 필터된 파일 리스트의 길이
    const currentInputLength = filterFiles.length;
    // 등록된 파일 리스트의 길이
    const currentUploadLength = selectedFiles.length;
    // 차감되는 파일 개수
    const subtractCnt = currentInputLength + currentUploadLength - 5;
    // 실제로 추가되는 파일의 길이
    const loofCnt = subtractCnt <= 0 ? currentInputLength : currentInputLength - subtractCnt;

    if (subtractCnt > 0) alert('파일은 최대 5개까지 첨부 가능합니다.');
    if (filterFiles.length !== files.length) alert('300MB 이하, MP3, PDF 파일만 업로드 가능합니다.');

    if (filterFiles && filterFiles.length > 0) {
      for (let i = 0; i < loofCnt; i++) {
        const file = filterFiles[i];

        // 사실 해당 분기를 진입 할 수 없음
        if (file.size >= MAX_SIZE) {
          alert('파일은 300MB 이하만 가능합니다.');
    
        } else {
          setSelectedFiles(prev => {
            const temp = [...prev];
            temp.push(file);
            return temp;
          });
    
          setIds(prev => {
            const uuid = uuidv4();
            const extension = file.name.split(".").pop();
    
            const temp = [...prev];
            temp.push(`${uuid}.${extension}`);
            return temp;
          });
        }
      }
    }

    // input file 초기화 (안시키면 값을 계속 event의 value값이 이전 파일을 계속 물고있음)
    _file.current.value = '';
  };

  async function uploadFile(file, fileKey) {
    return new Promise(async function(resolve, reject) {
      const params = {
        Body: file,
        Bucket: S3_BUCKET,
        Key: fileKey,
      };

      await myBucket.putObject(params)
        .on('httpUploadProgress', evt => {
          setProgress(Math.round((evt.loaded / evt.total) * 100))
        })
        .on('complete', evt => {
          console.log(evt);
          if (evt.error) reject(evt.error);
          else resolve(evt);
        })
        .send((err, data) => {
          console.log(data);
          if (err) {
            reject(err);
            setSending(false);
          }
        });
    });
  }

  const clickDeleteFile = idx => {
    const tempFiles = [...selectedFiles];
    const tempIds = [...ids];

    tempFiles.splice(idx, 1);
    tempIds.splice(idx, 1);

    setSelectedFiles(tempFiles);
    setIds(tempIds);
  };

  const changeState = e => {
    const { name, value } = e.currentTarget;

    if (name === 'name' && !value.match(/^[ㄱ-ㅎ|ㅏ-ㅣ|가-힣|a-z|A-Z|\s]{0,40}$/)) return;
    if (name === 'phone' && !/^[0-9]{0,11}$/.test(value)) return;
    if (name === 'introduce' && value.length > 800) return alert('최대 800자까지 입력할 수 있습니다.');
    if (name === 'description' && value.length > 800) return alert('최대 800자까지 입력할 수 있습니다.');

    setState(prev => {
      return {
        ...prev,
        [name]: value,
      }
    });
  };

  const regist = async () => {
    try {
      const errorCode = [501, 502, 503, 504, 505, 506, 507, 508];
      const res = await apiCall.post(`${LIVE_URL}/api/v1/event/2022/supporters`, {
        ...empty2null(state),
        portfolioList: ids,
      });

      if (!res) {
        alert('본 이벤트는 조기 마감되었습니다. 감사합니다.');
      } else {
        if (errorCode.includes(res.code)) {
          alert(res?.msg ?? '서버에러가 발생했습니다.');
        } else if (res.code === 200) {
          alert('룸메이트 1기 지원이 완료되었습니다.');
          window.close();
        }
      }

      setSending(false);

    } catch(err) {
      console.log(err);
      setSending(false);
      alert(err?.msg ?? '서버에러가 발생했습니다.');
    }
  };

  const submit = () => {
    if (!agree) return alert('본 이벤트는 개인정보 수집/이용 항목에 동의 후 참여가능 합니다.');
    if (state.name === '') return alert('이름을 입력해 주세요.');
    if (state.phone === '') return alert('연락처를 입력해 주세요.');
    if (state.email === '') return alert('이메일을 확인해 주세요.');
    if (state.college === '') return alert('학교/전공을 입력해 주세요.');
    if (state.collegeStatus === '') return alert('학적상태를 선택해 주세요.');
    if (state.region === '') return alert('거주지를 입력해 주세요.');
    if (state.livingAloneExperience === '') return alert('자취 경험 유무를 선택해 주세요.');
    if (state.livingAlonePeriod === '') return alert('자취기간을 입력해 주세요.');
    if (state.introduce === '') return alert('자소서 항목을 입력해 주세요.');
    if (state.description === '') return alert('자소서 항목을 입력해 주세요.');

    if (isSending) return;

    setSending(true);

    const promiseFiles = [];

    if (selectedFiles && selectedFiles.length > 0) {
      for (let i = 0; i < selectedFiles.length; i++) {
        promiseFiles.push(uploadFile(selectedFiles[i], ids[i]));
      }

      Promise.all(promiseFiles)
        .then(async (values) => {
          console.log(values);
          regist();
        }, reason => {
          console.log(reason);
          alert('파일 업로드 중 에러가 발생했습니다.');
        })
        .catch(err => {
          console.log(err);
          alert('파일 업로드 중 에러가 발생했습니다.');
        });
    }
    else regist();
  };

  if (isM) return null;

  return (
    <FormBody>
      {isSending && (
        <Overlay>
          <div className="ball-wrap">
            <div className="sp-3balls" />
          </div>
        </Overlay>
      )}
      <BG width={640} height={594} imgUrl={form_top} />
      <FormWrap>
        <Label>이름<span>*</span></Label>
        <Input name="name" value={state.name} placeholder="김다방" onChange={changeState} />
        
        <Label style={{ marginTop: 50 }}>성별<span>*</span></Label>
        <RadioWrap>
          <RadioLabel>
            <Radio
              type="radio"
              name="gender"
              value="남자"
              onChange={changeState}
            />
            남자
          </RadioLabel>

          <RadioLabel style={{ marginLeft: 48 }}>
            <Radio
              type="radio"
              name="gender"
              value="여자"
              onChange={changeState}
            />
            여자
          </RadioLabel>
        </RadioWrap>
        
        <Label style={{ marginTop: 50 }}>연락처<span>*</span></Label>
        <Input name="phone" value={state.phone} placeholder="-없이 숫자 입력" onChange={changeState} />

        <Label style={{ marginTop: 50 }}>이메일<span>*</span></Label>
        <Input name="email" value={state.email} placeholder="dabang@dabang.com" onChange={changeState} />

        <Label style={{ marginTop: 50 }}>학적상태<span>*</span></Label>
        <RadioWrap>
          <RadioLabel>
            <Radio
              type="radio"
              name="collegeStatus"
              value="재학"
              onChange={changeState}
            />
            재학
          </RadioLabel>

          <RadioLabel style={{ marginLeft: 48 }}>
            <Radio
              type="radio"
              name="collegeStatus"
              value="휴학"
              onChange={changeState}
            />
            휴학
          </RadioLabel>
        </RadioWrap>

        <Label style={{ marginTop: 50 }}>학교/전공<span>*</span></Label>
        <Input name="college" value={state.college} placeholder="다방대학교/부동산학과" onChange={changeState} />

        <Label style={{ marginTop: 50 }}>거주지<span>*</span></Label>
        <Input name="region" value={state.region} placeholder="경기도 다방시 (시까지 입력해주세요.)" onChange={changeState} />

        <Label style={{ marginTop: 50 }}>자취 경험 유무<span>*</span></Label>
        <RadioWrap>
          <RadioLabel>
            <Radio
              type="radio"
              name="livingAloneExperience"
              value="있음"
              onChange={changeState}
            />
            있음
          </RadioLabel>

          <RadioLabel style={{ marginLeft: 48 }}>
            <Radio
              type="radio"
              name="livingAloneExperience"
              value="없음"
              onChange={changeState}
            />
            없음
          </RadioLabel>
        </RadioWrap>

        <Label style={{ marginTop: 50 }}>자취기간<span>*</span></Label>
        <Input name="livingAlonePeriod" value={state.livingAlonePeriod} placeholder="1년 (없을경우 없음으로 입력해주세요.)" onChange={changeState} />

        <Label style={{ marginTop: 50 }}>인스타그램 계정 (선택)</Label>
        <Input name="instagramAccount" value={state.instagramAccount} placeholder="instagram.com/dabang_app" onChange={changeState} />

        <Label style={{ marginTop: 50 }}>네이버 블로그 계정 (선택)</Label>
        <Input name="naverBlogAccount" value={state.naverBlogAccount} placeholder="https://blog.naver.com/station3inc" onChange={changeState} />

        <IntroduceTitle>자소서 항목</IntroduceTitle>

        <Label style={{ marginTop: 50 }}>1. 자기소개 및 지원동기<span>*</span></Label>
        <TextareaComponent name="introduce" value={state.introduce} placeholder="800자로 제한합니다." changeState={changeState} />

        <Label style={{ marginTop: 50 }}>2. 자신 있는 역할<span>*</span></Label>
        <RadioWrap>
          <RadioLabel>
            <Radio
              type="radio"
              name="role"
              value="영상"
              onChange={changeState}
            />
            영상
          </RadioLabel>

          <RadioLabel style={{ marginLeft: 48 }}>
            <Radio
              type="radio"
              name="role"
              value="기획"
              onChange={changeState}
            />
            기획
          </RadioLabel>

          <RadioLabel style={{ marginLeft: 48 }}>
            <Radio
              type="radio"
              name="role"
              value="부동산"
              onChange={changeState}
            />
            부동산
          </RadioLabel>

          <RadioLabel style={{ marginLeft: 48 }}>
            <Radio
              type="radio"
              name="role"
              value="디자인"
              onChange={changeState}
            />
            디자인
          </RadioLabel>
        </RadioWrap>

        <Label style={{ marginTop: 50 }}>3. 그렇게 선택한 이유를 경험과 함께 이야기 해주세요.<span>*</span></Label>
        <TextareaComponent name="description" value={state.description} placeholder="800자로 제한합니다." changeState={changeState} />

        <Label style={{ marginTop: 50 }}>포트폴리오 파일 제출 (선택)</Label>
        {selectedFiles && selectedFiles.length > 0 && selectedFiles.map((file, idx) => (
          <UploadFile key={uuidv4()}>
            <p>{file.name}</p>
            <img src={close} alt="close" style={{ width: 24, height: 24 }} onClick={() => clickDeleteFile(idx)} />
          </UploadFile>
        ))}
        <UploadBtn htmlFor="file-upload" isDisabled={selectedFiles.length === 5}>
          <span>파일첨부</span>
          <input ref={_file} type="file" id="file-upload" onChange={e => clickSelectFile(e)} accept=".mp4, .pdf" disabled={selectedFiles.length === 5} multiple />
        </UploadBtn>

        <UploadText>-mp4, pdf 파일만 제출 가능합니다.</UploadText>
        <UploadText>-파일첨부는 최대5개, 용량은 파일당 300MB 이하만 가능합니다.</UploadText>

        <Label style={{ marginTop: 50 }}>포트폴리오 URL 제출 (선택)</Label>
        <Input name="portfolioUrl" value={state.portfolioUrl} placeholder=" https://" onChange={changeState} />
      </FormWrap>

      <TermsWrap isOpen={open}>
        <div>
          <label>
            <Checkbox type="checkbox" checked={agree} onChange={() => setAgree(prev => !prev)} />
            <p>개인정보 수집/이용에 대한 동의</p>
            <Arrow fn={clickOpenTerms} />
          </label>
        </div>

        {open && (
          <ul>
            <li>1. 개인정보 수집 및 이용목적 : 서포터즈 지원자 관리 및 서포터즈 선출</li>
            <li>2. 수집하려는 개인정보의 항목 : 지원자의 인적사항(이름, 휴대폰번호, 생년월일, 학교, 학과 등)</li>
            <li>3. 개인정보의 보유 및 기간 : 서포터즈 활동 종료시까지</li>
            <li>4. 본 개인정보 제공에 동의를 거부할 권리가 있으며 동의 거부시 서포터즈 지원 불가합니다.</li>
          </ul>
        )}
      </TermsWrap>

      <QuestionText>문의사항 : dabangroommate@gmail.com</QuestionText>

      <BG width={1280} height={280} imgUrl={submit_btn} />
      <button onClick={submit} />
    </FormBody>
  );
}

export default SupportersForm;
